<template>
  <section class="modal-inner">
    <div class="content-wrap">

      <div class="login">
        <div class="content-header">
          <h2>{{$t('ログイン')}}</h2>
        </div>

        <div class="warning" id="warning" v-if="errors.length">
          <ul>
            <li v-for="(error, index) in errors" :key="index"> {{ error }}</li>
          </ul>
        </div>

        <form id="signin" @submit.prevent="login">
          <input v-model="email" v-on:blur="instantValidator($event, 'email')" name="email" :placeholder="this.$t('メールアドレス')" id="email" autocomplete="email" value="" type="text" spellcheck="false" />
          <p class="caution" id="email-c">{{emailError}}</p>
          <input v-model="password" type="password" v-on:blur="instantValidator($event, 'password')" :placeholder="this.$t('パスワード')" id="u_auth_val" autocomplete="new-password" />
          <p class="caution" id="password-c">{{passError}}</p>
          <div class="txt-right"><a :href="constants.MATCHA_SITE + this.$store.state.languageName + '/user/password_reset'">{{$t('パスワードをお忘れの方はこちら')}}</a></div>
          <button type="submit">{{$t('ログイン')}}</button>
        </form>
        <div class="txt-center">
          <a :href="constants.MATCHA_SITE + this.$store.state.languageName + '/user/index'">{{$t('アカウントをお持ちでない方はこちら')}}</a>
        </div>
      </div>

      <div class="social-login-section sns_login">
        <!-- Facebook Login Section  -->
        <!-- <fb-signin-button
          :params="fbSignInParams"
          @success="onSignInSuccessFB"
          @error="onSignInErrorFB" class="loginBtn loginBtn--facebook facebook">
          <i class="icon-facebook"></i>
          Sign in with Facebook
        </fb-signin-button> -->

        <button v-facebook-signin-button="appId" class="loginBtn loginBtn--facebook facebook"> 
            <i class="icon-facebook"></i>
            Sign in with Facebook
        </button>

        <!-- End of Facebook Login Section  -->
        <!-- Google Sign In Button -->
        <div class="loginBtn loginBtn--google googleplus g-signin2">
          <a href="javascript:;" @click.prevent="googleLogin()">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="googleIcon">
              <g>
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path>
              </g>
            </svg>
            <span>Sign in with Google</span>
          </a>
        </div>
        
        <!-- End of Google Sign In Button -->
      </div>

    </div> 
  </section>
</template>


<script>
import * as constants from '@/constants'
import { mapState, mapGetters, mapMutations } from 'vuex'
import cognitoUser from '@/api/cognito-user'
import Cookie from 'js-cookie'
import UserUtils from '@/utils/UserUtils'
import { defaults, get, delete as _delete } from "axios"
import Vue from 'vue'
import FacebookSignInButton from 'vue-facebook-signin-button-directive'

export default {

  data : () => ({
    email: null,
    password: null,
    errors:[],
    emailError: '',
    passError: '',
    constants: constants,
    appId: process.env.FACEBOOK_APP_ID,
    fbSignInParams: {
      scope: 'public_profile,email',
      return_scopes: true
    }
  }),
  methods:{
    /**
     * Facebook Sign In Section 
     */
    OnFacebookAuthSuccess (response) {
      // console.log(response)
      cognitoUser.snsRegistrationFB(response)
      .then((result) => {
        this.$store.dispatch('setUserMeta', result)
        this.setLoginSession(result)
      })
      .catch((error) => {
        this.removeCookies()
        this.errors.push((error.message != '200')?this.$t(error.message):this.$t('User not found!'))
      })      
    },
    OnFacebookAuthFail (error) {
      store.state.loginExecuteStatus =  'Session Expired!'
      // console.log('OH NOES', error)
    },    

    /**
     * Google Signin Section
     */
    googleLogin(){
      Vue.googleAuth().directAccess()
      Vue.googleAuth().signIn(this.onSignInSuccess, this.onSignInError)
    },

    onSignInSuccess (googleUser) {
      const authResponse = googleUser.getAuthResponse()
  
      cognitoUser.snsRegistrationGoogle(authResponse)
      .then((result) => {
        // console.log(result)
        this.$store.dispatch('setUserMeta', result)
        this.setLoginSession(result)
      })
      .catch((error) => {
        // console.log(error)
        this.removeCookies()
        this.errors.push((error.message != '200')?this.$t(error.message):this.$t('User not found!'))
      })
    },
    onSignInError (error) {
      store.state.loginExecuteStatus =  'Session Expired!'
      // console.log('OH NOES', error)
    },    

    /**
     * Cognito User Pool Sign In Section
     */
    instantValidator(el, type){
      if(type === undefined) return; 
      if(type === 'email'){
        if(!this.email){
          this.emailError = this.$t("Email field is empty.")
        }else if(!this.emailValidator(this.email)){
          this.emailError = this.$t("Invalid email adrress.")
        }else{
          this.emailError = ""
        }
      }else if(type === 'password'){
        if(!this.password){
          this.passError = this.$t('Password field is empty.')
        }else if(!this.passwordValidator(this.password)){
          if(this.password.length < 6){
            this.passError = this.$t('Please set a password with more than 6 characters.')
          }else if(this.password.length > 16){
            this.passError = this.$t('Please set a password with less than 16 characters.')
          }else if(!(/^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9])+$/.test(this.password))){
            this.passError = this.$t('Password should contain both alphabets and numbers.')
          }else{
            this.passError = this.$t('Invalid password format.')
          }          
        }else{
          this.passError = ''
        }
      }
    },
    login(){
      if(!this.checkForm()) return
      this.$store.dispatch('login', {email:this.$sanitize(this.email), password: this.$sanitize(this.password) })
      .then((res) => {
        let result = res.result
        this.setLoginSession(res.session)
        let languageName = UserUtils.convertToLanguageName(this.getNestedObject(result, ['idToken', 'payload', 'custom:lang_id']))
        window.location.href = '/'
      })
      .catch((error) => {
        Cookie.set('_mua_c_aut_em', error.message)
        this.errors.push((error.message != '200')?this.$t(error.message):this.$t('Unknown error'))
      })
    },
    checkForm:function(e) {
      this.errors = [];
      if(!this.email) {
        this.errors.push(this.$t("Please input a valid email address."));
      } else if(!this.validEmail(this.email)) {
        this.errors.push(this.$t("Invalid email adrress."));        
      }
      if(!this.password) this.errors.push(this.$t("Please input a valid password."));
      if(!this.errors.length) return true;
    },
    validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    emailValidator:function(email) {
      if (!email) return false;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email);
    },
    passwordValidator:function(pass){
      if(!pass) return false;
      var re = /^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9]).{5,16}$/;   //previous one : /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      return re.test(pass);
    },
    getNestedObject: function(nestedObj, pathArr){
      return pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    },

    setLoginSession(sesData){
      var stamp = btoa(JSON.stringify(sesData));

      var loggedInStamp = Cookie.get('CognitoIdentity.s_stamp');
      if(loggedInStamp !== undefined){
        // Cookie.defaults = { domain: process.env.COOKIES_DOMAIN };
        Cookie.set('CognitoIdentity.Provider', sesData.provider, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.accessToken', sesData.accessToken, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.cognitoIdentiyId', sesData.cognitoIdentiyId, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.sns_registration', sesData.sns_registration, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.s_stamp', btoa(JSON.stringify(sesData), { domain: process.env.COOKIES_DOMAIN }));
        window.location.href = '/';
      }else{
        // Cookie.defaults = { domain: process.env.COOKIES_DOMAIN };
        Cookie.set('CognitoIdentity.Provider', sesData.provider, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.accessToken', sesData.accessToken, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.cognitoIdentiyId', sesData.cognitoIdentiyId, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.sns_registration', sesData.sns_registration, { domain: process.env.COOKIES_DOMAIN });
        Cookie.set('CognitoIdentity.s_stamp', stamp, { domain: process.env.COOKIES_DOMAIN });
        window.location.href = '/';
        // Should add  redirect point
      }
    },

    removeCookies(){
      Cookie.remove('CognitoIdentity.Provider', { domain: process.env.COOKIES_DOMAIN });
      Cookie.remove('CognitoIdentity.accessToken', { domain: process.env.COOKIES_DOMAIN });
      Cookie.remove('CognitoIdentity.cognitoIdentiyId', { domain: process.env.COOKIES_DOMAIN });
      Cookie.remove('CognitoIdentity.sns_registration', { domain: process.env.COOKIES_DOMAIN });
      Cookie.remove('CognitoIdentity.s_stamp', { domain: process.env.COOKIES_DOMAIN });
    }

  },

  //For Header & Meta Tag 
  metaInfo() {
    return {
      title: this.$t('ログイン') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE')
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/pages/users/login.vue